<template>
  <div class="about">
    <h1 class="about-title">
      gifteeとは
    </h1>
    <AboutCoverSection />
    <CreateGiftButton
      class="about-create-gift-button"
      @click-button="onClickCreateGiftButton"
    />
    <div class="scroll-down">
      <ScrollDownText />
    </div>
    <AboutDescriptionsSection />
    <AboutBrandsSection />
    <AboutHowToUsesSection />
    <AboutGiftTypesSection />
    <AboutGiftCardsSection />
    <AboutGoToGifteeTopSection />
    <AboutAppStoreSection />
  </div>
</template>
<script>
import AboutCoverSection from '../../organism/statics/abouts/AboutCoverSection'
import AboutDescriptionsSection from '../../organism/statics/abouts/AboutDescriptionsSection'
import AboutBrandsSection from '../../organism/statics/abouts/AboutBrandsSection'
import AboutHowToUsesSection from '../../organism/statics/abouts/AboutHowToUsesSection'
import AboutGiftTypesSection from '../../organism/statics/abouts/AboutGiftTypesSection'
import AboutGiftCardsSection from '../../organism/statics/abouts/AboutGiftCardsSection'
import AboutGoToGifteeTopSection from '../../organism/statics/abouts/AboutGoToGifteeTopSection'
import AboutAppStoreSection from '../../organism/statics/abouts/AboutAppStoreSection'
import CreateGiftButton from '../../molecules/buttons/CreateGiftButton'
import ScrollDownText from '../../atoms/texts/ScrollDownText'
export default {
  components: {
    AboutCoverSection,
    AboutDescriptionsSection,
    AboutBrandsSection,
    AboutHowToUsesSection,
    AboutGiftTypesSection,
    AboutGiftCardsSection,
    AboutGoToGifteeTopSection,
    AboutAppStoreSection,
    CreateGiftButton,
    ScrollDownText
  },
  methods: {
    onClickCreateGiftButton() {
      location.href = '/gift_card/new'
    }
  }
}
</script>
<style lang="scss" scoped>
.about {
  width: 100%;
  letter-spacing: 0.06em;

  &-title {
    display: none;
  }

  &-create-gift-button {
    position: fixed;
    right: 3%;
    bottom: 3%;
    z-index: 1;

    @media all and (max-width: $pc-width  - 1) {
      display: none;
    }
  }

  .scroll-down {
    position: absolute;
    left: 0;
    bottom: 0;

    @media all and (max-width: $pc-width  - 1) {
      display: none;
    }
  }
}
</style>
